import React from "react";

export default function Input({
  id,
  name,
  type = "text",
  required=true,
  autoComplete,
  placeholder,
  label,
  startIcon,
  endIcon,
  value,
  onChange,
  md,
  disabled=false
}) {
  return (
    <div className={`w-full p-2 ${md==6?'md:w-1/2':''}`} >
      <label htmlFor={id} className="block text-sm font-medium text-gray-900">
        {label || (name ? name.charAt(0).toUpperCase() + name.slice(1) : "")}
      </label>  
              
      <div className="relative mt-2 flex items-center">
        {startIcon && <span className="absolute left-3 text-gray-500">{startIcon}</span>}

        <input
          id={id}
          name={name}
          type={type}
          required={required}
          autoComplete={autoComplete}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 
            outline outline-2 h-10 outline-indigo-300 placeholder-gray-400
            focus:outline-2 focus:outline-indigo-600 sm:text-sm
            ${startIcon ? "pl-10" : ""} ${endIcon ? "pr-10" : ""}`}
        />

        {endIcon && <span className="absolute right-3  pe-5 text-gray-500">{endIcon}</span>}
      </div>
    </div>
  );
}
